module.exports = __webpack_public_path__ + "img/society-sacagawea-avatar.88506aa2.png";